module.exports = __webpack_public_path__ + "img/gmap.cb7eca5b.jpg";